/* =====================================
   KHUSHBU REVIEW DRAWER JS
   Minimog 4.0 Compatible
   v1.1 – QA fixes
===================================== */

(function () {

  if (window.__khReviewDrawerInit) return;
  window.__khReviewDrawerInit = true;

  function init() {

    var trigger  = document.querySelector(".kh-review-trigger");
    var drawer   = document.querySelector(".kh-review-drawer");
    var overlay  = document.querySelector(".kh-review-overlay");
    var closeBtn = document.querySelector(".kh-review-close");

    if (!drawer || !overlay || !closeBtn) return;

    var lastFocus = null;
    var FOCUSABLE =
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function isOpen() {
      return drawer.classList.contains("active");
    }

    function openDrawer(opener) {
      if (isOpen()) return;
      lastFocus = opener || document.activeElement;

      drawer.classList.add("active");
      overlay.classList.add("active");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("kh-review-open");
      if (trigger) trigger.setAttribute("aria-expanded", "true");

      // FIX: move keyboard / screen-reader focus into the dialog
      requestAnimationFrame(function () {
        closeBtn.focus({ preventScroll: true });
      });
    }

    function closeDrawer() {
      if (!isOpen()) return;

      drawer.classList.remove("active");
      overlay.classList.remove("active");
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("kh-review-open");
      if (trigger) trigger.setAttribute("aria-expanded", "false");

      // FIX: return focus to whatever opened it
      if (lastFocus && lastFocus.isConnected && lastFocus.focus) {
        lastFocus.focus({ preventScroll: true });
      }
    }

    if (trigger) {
      trigger.addEventListener("click", function () {
        openDrawer(trigger);
      });
    }

    // NEW: any element with data-kh-review-open can open the drawer
    // e.g. <a href="#" data-kh-review-open>★ 4.9 (24 reviews)</a> on the product page
    document.addEventListener("click", function (e) {
      var opener = e.target.closest("[data-kh-review-open]");
      if (!opener) return;
      e.preventDefault();
      openDrawer(opener);
    });

    closeBtn.addEventListener("click", closeDrawer);
    overlay.addEventListener("click", closeDrawer);

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && isOpen()) {
        closeDrawer();
      }
    });

    // FIX: keep Tab inside the dialog while it's open
    drawer.addEventListener("keydown", function (event) {
      if (event.key !== "Tab") return;

      var items = Array.prototype.slice.call(drawer.querySelectorAll(FOCUSABLE));
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    /* ============================
       SORT (was a dead button)
    ============================ */
    var sortBtn = drawer.querySelector(".kh-review-sort");
    var list = drawer.querySelector(".kh-review-list");
    var sortLabel = sortBtn && sortBtn.querySelector("[data-kh-sort-label]");

    var MODES = [
      { key: "featured", label: "Featured" },
      { key: "high", label: "Highest Ratings" },
      { key: "low", label: "Lowest Ratings" }
    ];
    var mode = 0;

    if (sortBtn && list) {
      sortBtn.addEventListener("click", function () {
        mode = (mode + 1) % MODES.length;
        var key = MODES[mode].key;

        var cards = Array.prototype.slice.call(list.querySelectorAll(".kh-review-card"));

        cards.sort(function (a, b) {
          var ia = +a.dataset.index, ib = +b.dataset.index;
          var ra = +a.dataset.rating, rb = +b.dataset.rating;
          if (key === "high") return rb - ra || ia - ib;
          if (key === "low") return ra - rb || ia - ib;
          return ia - ib;
        });

        cards.forEach(function (card) {
          list.appendChild(card);
        });

        if (sortLabel) {
          sortLabel.textContent = MODES[mode].label;
        } else {
          sortBtn.textContent = MODES[mode].label;
        }
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

})();
